import axios from "axios";

import env from "../variables/EndpointEnvironment";

const instance = axios.create({
  baseURL: env.HOST,
  timeout: 10000,
});

instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers = {
    "Content-Language": localStorage.getItem('i18nextLng'),
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});


export default instance;